import React from 'react';
import { Grid, TextField, Button, InputAdornment, CircularProgress } from '@material-ui/core'

import LS from '../../providers/LocalStorage'
import Ws from '../../providers/Ws';
import SpecificComponent from '../../commons/SpecificComponent';
import wallStreet from '../../Pics/wallStreet.jpg'

export default class SignUp extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            strU: '',
            strP: '',
            strRPass: '',
            vPassBlur: '',
            vUserBlur: '',
            loading:true
        }
    }



    componentDidMount() {

    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    passOnBlur = () => {
        if (this.state.strP === this.state.strRPass) {
            // console.log('yes :')
            this.setState({ vPassBlur: '' })
        } else {
            // console.log('no :')
            this.setState({ vPassBlur: this.dictionary.login.passWarn })
        }
    }

    userOnBlur = () => {
        if ((this.state.strU.length > 5) && (this.state.strU.includes('@'))) {
            this.setState({ vUserBlur: '' })
        } else {
            this.setState({ vUserBlur: this.dictionary.login.userWarn })

        }
    }

    checkAndLogin = async () => {

        if ((this.state.strU.length > 5) && (this.state.vUserBlur === this.state.vPassBlur)) {



            let WS = new Ws()
            // let signUp = await WS.insert('useri',{email:this.state.strU, });
            // console.log('loginServerResponse = ', loginServerResponse)


            // if(loginServerResponse.Succes){
            //     new LS().SetUserData(loginServerResponse.Content)

            //     console.log('All right simulare save = ')

            //     document.location.href='/'
            // }else{
            //     this.setState({labRez:loginServerResponse.Messsage})
            // }
            // let toSave = {idUser:'777', nume:'Popescu'}

        } else {

        }

    }



    render() {
        return (
            <div style={{ marginTop: 0, width: '100%', position: 'fixed' }}>

                <div className="pm-login-bg-image" style={{ backgroundImage: `url(${wallStreet})` }} ></div>
                <Grid container className="loginContainer" style={{ borderRadius: 16, marginTop: '35vh', marginBottom: 40 }} >

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="with-placeholder"
                            label={this.dictionary.login.user}
                            onBlur={this.userOnBlur}
                            margin="normal"
                            value={this.state.strU}
                            onChange={this.handleChange('strU')}
                            InputProps={{
                                startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                            }}
                        />
                    </Grid>
                    <span className='pm-warning-validate'>{this.state.vUserBlur}</span>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="password-input"
                            label={this.dictionary.login.password}
                            onBlur={this.passOnBlur}
                            type="password"
                            margin="normal"
                            value={this.state.strP}
                            onChange={this.handleChange('strP')}
                            InputProps={{
                                startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>lock</i></InputAdornment>,
                            }}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="rpassword-input"
                            label={this.dictionary.login.repeatPass}
                            type="password"
                            margin="normal"
                            onBlur={this.passOnBlur}
                            value={this.state.strRPass}
                            onChange={this.handleChange('strRPass')}
                            InputProps={{
                                startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>lock</i></InputAdornment>,
                            }}
                        />
                        <span className='pm-warning-validate'>{this.state.vPassBlur}</span>
                    </Grid>

                    <span className='pm-warning-validate'>{this.state.labRez}</span>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >
                        {this.state.loading &&
                            <CircularProgress
                                style={{
                                    width: 60,
                                    height: 60,
                                    color: '#25e048',
                                    marginTop: '40%'
                                }}
                                value={20}

                            />
                        }

                        {!this.state.loading &&
                            <Button variant="outlined" className='pm-login-button' color="primary" onClick={this.checkAndLogin}>
                                {this.dictionary.login.signUp}
                            </Button>
                        }

                        <span className='pm-login-signup-text-container'><span className='pm-appbar-list-text'>{this.dictionary.login.or}</span> <span onClick={() => { this.props.history.push('/') }} className='pm-appbar-signup-text'>{this.dictionary.login.logIn}</span></span>


                    </Grid>
                </Grid>
            </div>
        );
    }


}  // end class